import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Tabs, Icon, Menu, Dropdown, Button } from "antd";
import { menus } from "../slideMenu/menus";
import "./topMenu.less";
const TabPane = Tabs.TabPane;

class TopMenu extends Component {
    state = {
        panes: [],           //此处引用menus组件的第一个为起始页
        activeKey: ''
    }
    componentDidMount() {
        this.listenHistory = this.props.history.listen(e => {
            this.onListenHistory(e)
        })
        this.initSessionStrange()
    }
    componentWillUnmount() {
        this.unListenHistory()
    }
    unListenHistory() {                                            //---移除对路由的监听
        if (this.listenHistory) {
            this.listenHistory()
            this.listenHistory = null
        }
    }
    onListenHistory = e => {                                             //---监听路由
        var currentRouter = null
        menus.forEach(item => {
            if (currentRouter) {
                return
            }
            if (item.sub) {
                currentRouter = item.sub.find(subItem => subItem.key === e.pathname)
            } else if (item.key === e.pathname) {
                currentRouter = item
            }
        })
        if (currentRouter) {
            this.setState(e => {
                !e.panes.find(pane => pane.key === currentRouter.key) && e.panes.push(currentRouter)
                e.activeKey = currentRouter.key
                return e
            }, () => {
                this.setSessionStrange()
            })
        }
    }
    onChange = (activeKey) => {                                         //---监听tabs 切换
        this.setState({ activeKey });
        this.props.history.push(activeKey)
    }
    onEdit = (targetKey, action) => {                                   //---监听tabs 新增 和 移除
        if (action === 'remove') {
            // 如果关闭的是当前项,则需要跳转新路由
            if (this.props.location.pathname === targetKey) {
                let currentRemoveIndex = this.state.panes.findIndex(e => e.key === targetKey)

                // 如果是最后一个 , 则跳转到当前项的前一个, 否则跳转后一个
                if (currentRemoveIndex === this.state.panes.length - 1) {
                    this.props.history.push(this.state.panes[currentRemoveIndex - 1].key)
                } else {
                    this.props.history.push(this.state.panes[currentRemoveIndex + 1].key)
                }
            }
            this.setState(e => {
                e.panes = e.panes.filter(e => e.key !== targetKey)
                return e
            }, this.setSessionStrange)
        }
    }
    setSessionStrange = () => {                                           //---设置State到缓存中
        let currentState = JSON.stringify(this.state)
        sessionStorage.setItem('layout_top_menu_state', currentState);
    }
    initSessionStrange = () => {                                        //---设置缓存数据到State中
        let topMenuState = sessionStorage.getItem('layout_top_menu_state');
        if (!topMenuState) {
            this.onListenHistory({ pathname: this.props.location.pathname })
            return false
        }

        try {
            topMenuState = JSON.parse(topMenuState)
            this.setState({ ...topMenuState })
        } catch (error) {

        }
    }
    handleShowAction = (e) => {                                          //---监听右侧菜单事件
        if (e.key === '0') {
            window.location.reload()
        } else if (e.key === '1') {
            this.onEdit(this.state.activeKey, 'remove')
        } else if (e.key === '2') {
            this.setState(state => {
                state.panes = state.panes.filter((pane, i) => {
                    return pane.key === state.activeKey || i === 0
                })
                return state
            }, () => {
                this.setSessionStrange()
            })
        } else if (e.key === '3') {
            this.setState(state => {
                state.panes = state.panes.filter((pane, i) => {
                    return i === 0
                })
                return state
            }, () => {
                this.props.history.push(this.state.panes[0].key)
            })
        }
    }
    render() {
        const menu = (
            <Menu onClick={this.handleShowAction}>
                <Menu.Item key="0"> 刷新当前选项卡 </Menu.Item>
                <Menu.Divider />
                <Menu.Item key="1" disabled={this.state.panes.length < 2}> 关闭当前选项卡 </Menu.Item>
                <Menu.Item key="2" disabled={this.state.panes.length < 3}>关闭其他选项卡</Menu.Item>
                <Menu.Divider />
                <Menu.Item key="3" disabled={this.state.panes.length < 2}>关闭所有选项卡</Menu.Item>
            </Menu>
        );
        return <div className="topMenuComponent">
            <div className="topMenuBlock">
                <div className="left" style={{ width: 'calc( 100% - 90px )' }}>
                    <Tabs
                        hideAdd
                        onChange={this.onChange}
                        activeKey={this.state.activeKey}
                        type="editable-card"
                        onEdit={this.onEdit}
                        style={{ marginTop: '16px' }}
                    >
                        {
                            this.state.panes
                                ? this.state.panes.map(pane => {
                                    return <TabPane
                                        tab={
                                            <span>
                                                {
                                                    pane.key === this.state.activeKey
                                                        ? <Icon type={pane.icon} />
                                                        : <Icon type={pane.icon} />
                                                }
                                                {pane.title}
                                            </span>
                                        }
                                        key={pane.key}
                                        closable={pane.closable}
                                    />
                                })
                                : null
                        }
                    </Tabs>
                </div>
                <div className="right">
                    <Dropdown overlay={menu} trigger={['click']}>
                        <Button >选项<Icon type="down" /></Button>
                    </Dropdown>
                </div>
            </div>
            <div className="writeBlock" />
        </div>
    }
}
export default withRouter(TopMenu)


// WEBPACK FOOTER //
// ./src/layout/topMenu/topMenu.jsx